module.exports = __webpack_public_path__ + "img/credit-card1.74f16120.png";